import React, { Component } from 'react';
import PropTypes from 'prop-types';

import msg from 'msg';

import { getProductDetailsLink } from 'apps/products/links';
import ProductType from 'apps/products/models/ProductType';
import ProductLabel from 'apps/products/models/ProductLabel';
import OfferType from 'apps/products/models/OfferType';

import CouponLink from './CouponLink';
import FopCorner from '../../containers/fopPartials/FopCorner';
import ImageWithCorner from './ImageWithCorner';
import LastBoughtOrReviews from './LastBoughtOrReviews';
import MultilineTrim from 'widgets/MultilineTrim/MultilineTrim';
import OfferDescription from './OfferDescription';
import PackInfo from './PackInfo';
import ProductWarning from '../../containers/fopPartials/ProductWarning';
import FopTrackLink from '../../analytics/components/FopTrackLink';
import { BetaFeatures as FoodProfileBetaFeatures } from 'apps/foodProfile/consts';

class FopContent extends Component {
  static propTypes = {
    betaFeatures: PropTypes.array.isRequired,
    citrusAdData: PropTypes.object,
    fopMiddleContent: PropTypes.node,
    location: PropTypes.object.isRequired,
    onClick: PropTypes.func,
    params: PropTypes.object.isRequired,
    product: PropTypes.shape({
      sku: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      // TODO do we need it for FOPs ?
      // brand: PropTypes.shape({
      //   id: PropTypes.string.isRequired,
      //   name: PropTypes.string.isRequired,
      // }),
      catchWeight: PropTypes.string,
      price: PropTypes.object,
      // TODO do we need it for FOPs ?
      // categories: PropTypes.arrayOf(PropTypes.shape({
      //   id: PropTypes.string.isRequired,
      //   name: PropTypes.string.isRequired,
      // })),
      offer: PropTypes.object,
      image: PropTypes.object,
      averageRate: PropTypes.number,
      coupon: PropTypes.object,
      packInfo: PropTypes.object,
      type: PropTypes.oneOf(Object.keys(ProductType)),
    }).isRequired,
    productGtmData: PropTypes.object.isRequired,
    promotionGtmData: PropTypes.object.isRequired,
    pageParameters: PropTypes.object,
    router: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }),
    showCouponsLink: PropTypes.bool,
    usePredefinedLabelForEDLP: PropTypes.bool,
    moreExclusiveOffer: PropTypes.shape({
      moreOffersUrl: PropTypes.string,
      isMoreCardCustomer: PropTypes.bool,
    }),
  };

  shouldComponentUpdate(nextProps) {
    // check if it's worth to re-render as on changing item quantity in basket FOP content remain unchanged
    return (
      this.props.product !== nextProps.product
      || this.props.fopMiddleContent !== nextProps.fopMiddleContent
    );
  }

  get bopUrl() {
    const { betaFeatures, location, params, product } = this.props;

    return getProductDetailsLink({ product, location, params, betaFeatures });
  }

  getProductGtmData = () => {
    const { productGtmData } = this.props;
    this.productGtmData = this.productGtmData || {
      gtmEvent: 'gtm:productClick',
      gtmData: productGtmData,
      gtmDataUrl: this.bopUrl,
    };
    return this.productGtmData;
  };

  getPromotionGtmData = () => {
    const { promotionGtmData } = this.props;
    this.promotionGtmData = this.promotionGtmData || {
      gtmEvent: 'gtm:promotionClick',
      gtmData: promotionGtmData,
      gtmDataUrl: this.bopUrl,
    };
    return this.promotionGtmData;
  };

  getLastBoughtOrReview = () => {
    const {
      betaFeatures,
      product: { lastBoughtDate, reviewStats },
    } = this.props;

    const showCount = betaFeatures.includes('FOPS_SHOW_REVIEWS_COUNT');

    return (
      <LastBoughtOrReviews
        lastBoughtDate={lastBoughtDate}
        reviewStats={{ ...reviewStats, showCount }}
      />
    );
  };

  getOfferDescription = () => {
    const {
      citrusAdData,
      onFopPromotionClick,
      product,
      router,
      showCouponsLink,
      usePredefinedLabelForEDLP,
      moreExclusiveOffer,
    } = this.props;

    const { offer, labels = [] } = product;
    const shouldShowOffer = offer && !showCouponsLink;
    const isEdlp = labels.includes(ProductLabel.EDLP);
    const edlpMessage = !usePredefinedLabelForEDLP && offer
      ? offer.text
      : msg.fop.offer.edlp;
    const edlpOffer = { type: OfferType.EDLP, text: edlpMessage };

    if (!shouldShowOffer) {
      return false;
    }

    return (
      <OfferDescription
        {...this.getPromotionGtmData()}
        bopUrl={this.bopUrl}
        citrusAdData={citrusAdData}
        isClickable={!isEdlp}
        offer={isEdlp ? edlpOffer : offer}
        onClick={onFopPromotionClick}
        routerPush={router.push}
        moreExclusiveOffer={moreExclusiveOffer}
      />
    );
  }

  render() {
    const { bopUrl } = this;
    const {
      citrusAdData,
      fopMiddleContent,
      product,
      router,
      showCouponsLink,
      betaFeatures = [],
      pageParameters,
    } = this.props;

    return (
      <div className="fop-contentWrapper" onClick={this.onClickHandler} role="presentation">
        <FopTrackLink
          {...this.getProductGtmData()}
          pageParameters={pageParameters}
          citrusAdData={citrusAdData}
          routerPush={router.push}
          to={bopUrl}
        >
          <FopCorner product={product} />
          <div className="fop-content">
            <div className="fop-img-wrapper">
              <ImageWithCorner product={product} />
              <PackInfo
                product={product}
                showFPBadge={betaFeatures.includes(FoodProfileBetaFeatures.FOODMAESTRO_ENABLED)}
              />
            </div>
            <div className="fop-description">
              <h4
                className="fop-title"
                title={product.name}
              >
                <MultilineTrim maxLines={2}>
                  {product.name}
                </MultilineTrim>
                {product.catchWeight && <span className="fop-catch-weight-inline">{product.catchWeight}</span>}
              </h4>
              <span className="fop-catch-weight">{product.catchWeight}</span>
            </div>
          </div>
          {fopMiddleContent}
          <ProductWarning product={product} />
          {this.getLastBoughtOrReview()}
          {this.getOfferDescription()}
        </FopTrackLink>
        {showCouponsLink && (
          <CouponLink
            couponId={product.coupon.id}
            id={product.coupon.campaignId}
            name={product.coupon.campaignDisplayName}
          />
        )}
      </div>
    );
  }
}

export default FopContent;
